<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>


          <CCardBody>
            <BTabs :active-tab.sync="active_tab">
              <CTab :title="$t('components.driverDocumentList')">
                <DriverDocumentList/>
              </CTab>
              <CTab :title="$t('components.temporaryReturnDocuments')">
                <DriverReturnDocumentList/>
              </CTab>
              <CTab title="لیست بایگانی" v-if="get_access('delivery_report_baigani')">
                <DriverBaiganiDocumentList/>
              </CTab>

              <CTab title="پورسانت ویزیتور" v-if="get_access('visitor_porsant')">
                <VisitorPorsantDocumentList/>
              </CTab>
              <CTab title="گزارش رانندگان" v-if="get_access('visitor_porsant')">
                <DriverReportDocumentList/>
              </CTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BTabs from "../../tabs/BTabs";

var items = [];
import DriverDocumentList from "../visitors/DriverDocumentList";
import DriverReturnDocumentList from "../visitors/DriverReturnDocumentList";
import DriverBaiganiDocumentList from "@/views/panel/delivery/DriverBaiganiDocumentList";
import VisitorPorsantDocumentList from "./VisitorPorsantDocumentList";
import DriverReportDocumentList from "./DriverReportDocumentList";

export default {
  name: 'SaleSettingsComponent',
  components: {
    BTabs,
    DriverDocumentList,
    DriverReturnDocumentList,
    DriverBaiganiDocumentList,
    VisitorPorsantDocumentList,
    DriverReportDocumentList
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

      active_tab: localStorage.getItem("delivery_report_setting_active_tab"),

    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    if (this.active_tab == null) {
      this.active_tab = 0
    } else {
      this.active_tab = parseInt(localStorage.getItem("delivery_report_setting_active_tab"))
    }

  }, watch: {

    'active_tab': function () {
      localStorage.setItem("delivery_report_setting_active_tab", this.active_tab)
    }
  },
  methods: {}
}

</script>
